import React from 'react';
import { connect } from 'react-redux';
import useScroll from 'react-router-scroll/lib/useScroll'; // https://github.com/taion/react-router-scroll#minimizing-bundle-size
import { IndexRedirect, Redirect, IndexRoute, Router, Route, applyRouterMiddleware } from 'react-router';

import ContainerPage from 'containers/page/index';
import HomePage from 'containers/home/index';
import DataPage from 'containers/data/index';
import CountryPage from 'containers/country-profiles/index';
import CountryDetailPage from 'containers/country-profiles/show';
import ComparePage from 'containers/compare/index';
import PublicationsAndData from 'containers/publicationsAndData/index';
import MediaCenterPage from 'containers/media-center/index';

import { shouldUpdateScroll, trackPageView } from './actions';
import { initDataParams, updateDataParams } from './actions/data';
import { initCountryProfilesParams, updateCountryProfilesParams } from './actions/country-profiles';
import { initCompareParams, updateCompareParams } from './actions/compare';

const Routes = ({ history }) => (
  <Router
    history={history}
    render={applyRouterMiddleware(useScroll(shouldUpdateScroll))}
    onUpdate={trackPageView}
  >
    <Route path="/" component={ContainerPage}>
      <IndexRoute component={HomePage} />
      <Route path="data">
        <IndexRedirect to="both/issue" />
        <Route path=":sector/:displayBy" component={DataPage} onEnter={initDataParams} onChange={updateDataParams} />
      </Route>
      <Route path="country-profiles">
        <IndexRoute component={CountryPage} />
        <Route path=":country(/:sector)" onEnter={initCountryProfilesParams} onChange={updateCountryProfilesParams} component={CountryDetailPage} />
      </Route>
      <Route path="compare" component={ComparePage} onEnter={initCompareParams} onChange={updateCompareParams} />
      <Route path="media-center(/:section)" component={MediaCenterPage} />
      <Route path="publications-data(/:section)" component={PublicationsAndData} />
      <Redirect from="*" to="/" />
    </Route>
  </Router>
);

Routes.propTypes = {
  history: React.PropTypes.object
};

export default connect()(Routes);



// WEBPACK FOOTER //
// ./app/routes/Routes.jsx